// Emoji constants for UI elements
// These are decorative and don't need translation
export const EMOJI_REPLY = '↩️';
export const EMOJI_REPLY_ALL = '↩️↩️';
export const EMOJI_FORWARD = '↪️';
export const EMOJI_SNOOZE = '📥';
export const EMOJI_CLOCK = '⏰';
export const EMOJI_ARCHIVE = '📦';
export const EMOJI_EMAIL = '📧';
export const EMOJI_USER = '👤';
export const EMOJI_THREAD = '💬';
export const EMOJI_SETTINGS = '⚙️';
export const EMOJI_GOAL = '🎯';
export const EMOJI_POSITIVE = '😊';
export const EMOJI_NEGATIVE = '😟';
export const EMOJI_NEUTRAL = '😐';
export const EMOJI_POOF = '💨';
export const EMOJI_PLANE = '✈️';
export const EMOJI_REFRESH = '🔄';
export const EMOJI_CHECK = '✓';
export const EMOJI_WRITE = '✍️';
export const EMOJI_WRENCH = '🔧';
export const EMOJI_WARNING = '⚠️';
export const EMOJI_CLOSE = '✕';
export const EMOJI_EXPAND = '⛶';
export const EMOJI_DATABASE = '🗄️';
export const EMOJI_SEARCH = '🔍';
export const EMOJI_LINK = '🔗';
export const EMOJI_SELECTED = '●';
export const EMOJI_BUG = '🐛';
export const EMOJI_SYNC = '🔄';
export const EMOJI_OCTOPUS = '🐙';
export const EMOJI_STAR = '⭐';
export const EMOJI_BACK = '⬅️';
export const EMOJI_ISSUE = '🔵';
export const EMOJI_PR = '🟣';
export const EMOJI_COMMENT = '💬';
export const EMOJI_CLIPBOARD = '📋';
export const EMOJI_NOTE = '📝';
export const EMOJI_LIGHTBULB = '💡';
export const EMOJI_INBOX = '📥';
export const EMOJI_BLOCK = '🚫';
export const EMOJI_SIREN = '🚨';
export const EMOJI_LIGHTNING = '⚡';
export const EMOJI_CALENDAR = '📅';
export const EMOJI_LOCATION = '📍';
export const EMOJI_PEOPLE = '👥';
export const EMOJI_DELETE = '🗑️';
export const EMOJI_TRASH = '🗑️';
export const EMOJI_INFO = 'ℹ️';
export const EMOJI_MENU = '☰';
export const EMOJI_DOWNLOAD = '⬇️';
export const ICON_CLEAR_FORMATTING = 'T̶ₓ';
export const EMOJI_SHIELD = '🛡️';
export const EMOJI_ROBOT = '🤖';
